import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';

const IssueReturnItem = ({ onRequisitionData, itemData, formData, currencyPrecision }) => {
    const apiService = new ApiService();
    const [rowsUpdated, setRowsUpdated] = useState(false);
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        uom: '',
        qty: '',
        amount: '',
        invQty: '',
        convRate: '',
        stock: '',
        unitPrice: '',
        balpo: '',
        cgsAcc: '',
        cgsAccName: '',
        balQty: ''
    }]);
    const totalAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0)
    // const totalVatAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0)
    useEffect(() => {
        getItems();
    }, [formData, itemData]);
    useEffect(() => {
        getItems();
    }, []);
    const getItems = async () => {
        try {
            if (itemData) {
                const formattedRowsPromises = formData?.issueReturnDetails?.map(async (detail, index) => {
                    const selecteditm = await apiService.getApiParamater('GET_ISSUE_RETURN_ITEM', `?IssueNo=${formData?.issueNo}&Mode=1`);
                    const item = selecteditm?.data.result?.find(req => req.itemDescription === detail.itemDescription);
                    return {
                        srno: index + 1,
                        ItemNo: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        specification: detail.specification,
                        uom: detail.uom,
                        amount: detail?.unitPrice * detail?.qty || 0,
                        qty: detail?.qty || 0,
                        // invQty: selectedItem.convToInvUOM * detail.qty,
                        invQty: detail?.invQty || 0,
                        convRate: detail.convToInvUOM,
                        stock: item?.balQty || 0,
                        unitPrice: detail.unitPrice || 0,
                        balpo: detail.cgsAcc,
                        balQty: item?.balQty,
                        cgsAcc: detail.cgsAccountCode,
                        cgsAccName: detail.cgsAccountName,
                    };
                }).filter(row => row !== null);

                const formattedRows = await Promise.all(formattedRowsPromises);

                if (formattedRows.length > 0) {

                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }
            } else {
                const formattedRowsPromises = formData?.issueDetails?.map(async (detail, index) => {
                    const selecteditm = await apiService.getApiParamater('GET_ISSUE_RETURN_ITEM', `?IssueNo=${formData?.issueNo.label}&Mode=1`);
                    const selecteditmstock = await apiService.getApiParamater('GET_ITEM', `?ItemNo=${detail.itemCode}&Warehouse=${formData?.location.label}`);
                    let glparam = `?ItemNo=${detail.itemCode}`
                    const getGLAccounts = await apiService.getApiParamater("GET_ITEM_GL", glparam);
                    let itemGl = getGLAccounts?.data?.result[0]
                    const item = selecteditm?.data.result?.find(req => req.itemDescription === detail.itemDescription);
                    const rowitem = rows?.find(req => req.itemDescription === detail.itemDescription);
                    let itemstock = selecteditmstock?.data?.result?.[0]

                    return {
                        srno: index + 1,
                        isrno: detail?.srno,
                        ItemNo: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        specification: detail.specification,
                        uom: detail.uom,
                        amount: detail?.unitPrice * rowitem?.qty || 0,
                        qty: rowitem?.qty || 0,
                        // invQty: selectedItem.convToInvUOM * detail.qty,
                        invQty: rowitem?.invQty || 0,
                        convRate: itemstock.convToInvUOM,
                        stock: item.balQty || 0,
                        unitPrice: item.unitPrice || 0,
                        balpo: detail.cgsAcc,
                        balQty: item.balQty,
                        cgsAcc: itemGl.cgsAccountCode,
                        cgsAccName: itemGl.cgsAccountName,
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows.length > 0) {
                    setRows(formattedRows);
                    onRequisitionData(formattedRows);
                }

                if (formData && formData.location.label && rows[0].ItemNo) {
                    updateRowsWithNewStock();
                    setRowsUpdated(true);
                }
            }

        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };
    const handleQtyChange = (index, value) => {
        const newQty = value || '';
        const balQty = rows[index].balQty;
        const unitPrice = rows[index].unitPrice;

        if (Number(newQty) > Number(balQty)) {
            toast.warning('Enter a quantity less than or equal to the Issue quantity.');
            return;
        }

        setRows(prevRows => {
            const newRows = [...prevRows];

            newRows[index] = {
                ...newRows[index],
                qty: newQty,
                amount: Number(newQty || 0) * Number(unitPrice || 0),
                invQty: Number(newQty || 0) * 1 || 1
            };

            const formattedRows = newRows.map(row => ({
                ...row
            }));

            onRequisitionData(formattedRows);

            return newRows;
        });
    };
    const updateRowsWithNewStock = async () => {
        try {
            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.ItemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM',
                    `?isActive=true&Warehouse=${formData?.location.label}&${queryParam}`
                );
                if (response?.data?.statusCode === 200) {
                    const itemData = response.data.result[0];
                    updatedRows[index].itemDescription = itemData.itemDescription;
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    const handleQtyKeyDown = (e, index) => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = index + 1;
            if (nextIndex < rows.length) {
                const nextInput = document.getElementById(`qty-${nextIndex}`);
                if (nextInput) {
                    nextInput.focus();
                    nextInput.select();
                }
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = index - 1;
            if (prevIndex >= 0) {
                const prevInput = document.getElementById(`qty-${prevIndex}`);
                if (prevInput) {
                    prevInput.focus();
                    prevInput.select();
                }
            }
        } else if (e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    };
    return (
        <div>
            <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Bal Qty</th>
                            <th>Inventory UOM</th>
                            <th>Inventory Qty</th>
                            <th>Unit Price</th>
                            <th>Amount</th>
                            <th>Stock</th>
                            <th>BalForPo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={row.srno} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'>
                                    <input
                                        className='p-2' style={{ width: "100px" }}
                                        id={`qty-${index}`}
                                        type="number" min={0} maxLength={row.qty} max={row.qty}
                                        onWheel={(e) => e.target.blur()}
                                        value={row.qty}
                                        disabled={formData?.eye} onKeyDown={(e) => handleQtyKeyDown(e, index)}
                                        onChange={(e) => handleQtyChange(index, e.target.value)}
                                    />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' value={row.balQty} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.uom} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.invQty} disabled style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.unitPrice || 0).toFixed(currencyPrecision || 0) || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balQty || 0} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balpo || 0} style={{ width: "120px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='d-flex boxs'>
                <div className='d-flex gap-2 center'>
                    <div className="totalhead center">Total Amount</div>
                    <div className='field'>{Number(totalAmount || 0).toFixed(currencyPrecision || 0) || "---"}</div>
                </div>
            </div>
        </div>
    );
};

export default IssueReturnItem;
